import React from 'react'; 
import {
  GoogleMap,
  Marker,
  useLoadScript,
} from "@react-google-maps/api";

import PropTypes from 'prop-types';
import i18n from '../../../assets/i18n';

const mapStyles = {
  width: 'unset',
  height: 'unset',
  margin: 3,
  zIndex: 1,
};
const containerStyle = {
  position: 'static',  
  width: '100%',
  height: '100%'
}

const MapContainer = ({data}) => {
  const location = data?.location || data;
  if (!location) return null;

  const {latitude, longitude, address, name} = location;
  const center = {
    lat: latitude,
    lng: longitude
  }

  const titleMessage = (_name, _address) => {
    if (_name && _address) return `${_name} ${_address}`;
    if (_name) return `${_name}`;
    if (_address) return `${_address}`;
    return '';
  }

  const {isLoaded, loadError} = useLoadScript({
    googleMapsApiKey: "AIzaSyBI8qgM3N2b-FolN3I_xDoMvrkv-ofOcps"
  });

  const handleMapClick = () => {
    const mapsUrl = `https://www.google.com/maps?q=${latitude},${longitude}`;
    window.open(mapsUrl, '_blank');
  };

  return (
    <>
      {isLoaded ?
        <>
          <div onClick={handleMapClick} style={{ cursor: 'pointer', width: '100%', height: '100%' }}>
            <GoogleMap
              mapContainerStyle={containerStyle}
              center={center}
              zoom={15}
              options={{ disableDefaultUI: true }}
              style={mapStyles}
            >
              <Marker title={titleMessage(name, address)} position={center} />
            </GoogleMap>
          </div>
          {(name || address) &&
            <div className="map-texts">
              <p className="map-text-name">{name}</p>
              <p>{address}</p>
            </div>
          }
        </>
        : <p>{i18n.auth.loading}</p>
      }
      {loadError && <p>{i18n.errors.locationFileNotAvailable}</p>}
    </>
  );
};

MapContainer.propTypes = {
  data: PropTypes.object,
};

export default MapContainer;